import { TFunction } from 'react-i18next';
import { ILists } from '../../interfaces/merchant';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { ADDRESS_FORM_FIELDS, ADDRESS_FORM_FIELDS_NAMES } from './address-form';
import { isUSCountry } from '../../utils/utilities';

interface IContactInformationInputsProps {
  lists: ILists
  t: TFunction;
  formik: any;
}

export const MERCHANT_ADDRESS_INPUTS = ({ t, lists, formik }: IContactInformationInputsProps): IFormInputProps[] => [
  {
    key: ADDRESS_FORM_FIELDS.LINE_1,
    fieldName: ADDRESS_FORM_FIELDS.LINE_1,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(ADDRESS_FORM_FIELDS_NAMES.LINE_1)}`,
    label: t(ADDRESS_FORM_FIELDS_NAMES.LINE_1),
    inputType: InputType.Text,
    // required: true,
  },
  {
    key: ADDRESS_FORM_FIELDS.LINE_2,
    fieldName: ADDRESS_FORM_FIELDS.LINE_2,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(ADDRESS_FORM_FIELDS_NAMES.LINE_2)}`,
    label: t(ADDRESS_FORM_FIELDS_NAMES.LINE_2),
    inputType: InputType.Text,
    // required: false,
  },
  {
    key: ADDRESS_FORM_FIELDS.CITY,
    fieldName: ADDRESS_FORM_FIELDS.CITY,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(ADDRESS_FORM_FIELDS_NAMES.CITY)}`,
    label: t(ADDRESS_FORM_FIELDS_NAMES.CITY),
    inputType: InputType.Text,
    // required: true,
  },
  {
    key: ADDRESS_FORM_FIELDS.ZIPCODE,
    fieldName: ADDRESS_FORM_FIELDS.ZIPCODE,
    placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(ADDRESS_FORM_FIELDS_NAMES.ZIPCODE)}`,
    label: t(ADDRESS_FORM_FIELDS_NAMES.ZIPCODE),
    inputType: InputType.Text,
    // required: true,
    additionalClasses: 'number-input-zip',
  },
  {
    key: ADDRESS_FORM_FIELDS.COUNTRY,
    fieldName: ADDRESS_FORM_FIELDS.COUNTRY,
    placeholder: t(ADDRESS_FORM_FIELDS_NAMES.COUNTRY),
    label: t(ADDRESS_FORM_FIELDS_NAMES.COUNTRY),
    inputType: InputType.Select,
    // required: true,
    disabled: false,
    data: lists.countries,
  },
  {
    key: ADDRESS_FORM_FIELDS.STATE,
    fieldName: ADDRESS_FORM_FIELDS.STATE,
    placeholder: t(ADDRESS_FORM_FIELDS_NAMES.STATE),
    label: t(ADDRESS_FORM_FIELDS_NAMES.STATE),
    inputType: InputType.Select,
    // required: true,
    data: lists.states,
    placement: 'bottomEnd',
    dataCy: 'state',
    disabled: !isUSCountry(formik.getFieldProps(ADDRESS_FORM_FIELDS.COUNTRY).value)
  },
];
